import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { RegisterSystemUserRequest } from './registration.types';

export const requestRegisterSystemUser =
  createAction<SagaPayload<RegisterSystemUserRequest, string>['payload']>('request/registerSystemUser');
